import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="3.38mm"
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 48864 98306"
    {...props}
  >
    <path
      d="M26880 87183V68515c1343-824 2242-2303 2242-3994 0-1692-899-3171-2242-3995v-1389c1343-824 2242-2302 2242-3994s-899-3169-2242-3995v-1388c1343-825 2242-2303 2242-3994 0-1693-899-3170-2242-3995v-695h21984L44708 2867H27297c0-1583-1282-2867-2865-2867s-2867 1284-2867 2867H4156L0 41076h21984v695c-1343 825-2242 2303-2242 3995 0 1691 899 3169 2242 3994v1390c-1343 824-2242 2301-2242 3993s899 3170 2242 3994v1389c-1343 824-2242 2303-2242 3995 0 1691 899 3170 2242 3994v18668c-6447 281-11344 1651-11344 3299v5289s4811 1869 11344 2398c1549 126 3194 175 4894 105 3661-146 7577-835 11346-2503v-5289c0-1648-4895-3018-11344-3299z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
